var _path, _path2, _path3, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKidsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.5767 23.1794C18.8887 25.2527 18.9687 27.0501 18.8487 28.6994L18.6367 28.9821C18.9594 28.5354 19.306 28.0887 19.6634 27.6714C20.0146 27.2512 20.397 26.8581 20.8074 26.4954C21.1607 26.1914 21.49 25.9687 21.798 25.8381L21.9514 25.7794L22.1087 26.2541C21.83 26.3474 21.5007 26.5581 21.134 26.8741C20.743 27.221 20.378 27.5962 20.042 27.9967C19.8084 28.2712 19.5826 28.5522 19.3647 28.8394L19.042 29.2754C18.9247 29.4381 18.826 29.5781 18.75 29.6887C18.6435 30.5421 18.4769 31.3868 18.2514 32.2167H17.7687C17.9714 31.4674 18.1287 30.6914 18.2354 29.8794L18.23 29.8821L18.1634 29.7754L18.0847 29.6047C17.9594 29.3448 17.8214 29.0912 17.6714 28.8447C17.1588 27.9967 16.5386 27.2186 15.826 26.5301C15.4232 26.1275 14.9899 25.7566 14.53 25.4207L14.7874 25.0127L15.154 25.2861C15.514 25.5647 15.854 25.8594 16.174 26.1714C17.0301 26.9985 17.7577 27.9491 18.3327 28.9914C18.4754 27.2767 18.4034 25.3941 18.0834 23.2541C18.0783 23.2216 18.0796 23.1885 18.0874 23.1567C18.0952 23.1248 18.1092 23.0948 18.1287 23.0683C18.1482 23.0419 18.1727 23.0196 18.2009 23.0028C18.229 22.9859 18.2602 22.9748 18.2927 22.9701C18.3251 22.965 18.3582 22.9663 18.3901 22.9741C18.422 22.9819 18.452 22.9959 18.4784 23.0154C18.5048 23.0349 18.5271 23.0594 18.544 23.0876C18.5609 23.1157 18.572 23.1469 18.5767 23.1794Z",
    fill: "#8595AD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.2447 8.71807C29.894 9.13273 30.4713 9.65807 30.9313 10.2821C31.3607 10.8687 31.8047 11.6074 32.018 12.2994C32.1607 12.7594 32.2487 13.2541 32.2713 13.7327C32.322 14.7181 32.146 15.7381 31.8953 16.6887C31.4953 18.1927 30.7047 19.6807 29.7487 20.9274C27.5887 23.7487 24.3647 25.2741 22.2593 25.0661L22.2527 26.3634C22.2527 26.3634 21.5233 26.2247 21.1487 25.9367C21.2367 25.5034 21.6073 25.0567 21.7753 24.8727C21.2393 24.5607 20.5647 23.9061 19.938 22.9781C22.7513 21.1861 26.858 16.1074 25.1113 9.07407C24.9873 8.57617 24.8327 8.08636 24.6487 7.6074C26.2604 7.47191 27.8727 7.86153 29.2447 8.71807Z",
    fill: "url(#paint0_linear_9299_1709)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.49005 9.33154H7.58605C7.50619 10.1735 7.51245 11.0215 7.60472 11.8622C7.78472 13.7262 8.48072 15.6449 9.43539 17.3115C10.9554 19.9609 13.2861 21.9515 15.4941 22.9555C15.2874 23.7182 15.0127 24.3155 14.7341 24.6889C14.9474 24.8009 15.4381 25.0902 15.6714 25.4609C15.4741 25.8209 14.9781 26.1662 14.8794 26.2315L14.8634 26.2422L14.3807 25.0342C12.6101 25.9609 9.22605 25.6542 6.29539 23.7715C5.00205 22.9422 3.76072 21.8302 2.85939 20.5649C2.29272 19.7689 1.76472 18.8755 1.44605 17.9422C1.29108 17.4801 1.18909 17.002 1.14205 16.5169C1.07672 15.7982 1.19539 14.9569 1.35805 14.2595C1.53037 13.5294 1.83691 12.8377 2.26205 12.2195C3.43005 10.5075 5.42205 9.38888 7.49005 9.33154Z",
    fill: "url(#paint1_linear_9299_1709)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5166 11.3022C32.006 14.2489 31.1406 17.8982 29.714 20.1035C31.322 15.2476 29.7193 11.7942 29.7193 11.7942C29.7193 11.7942 30.23 11.5209 30.5166 11.3022ZM29.2126 10.0222C29.2126 10.0222 29.802 10.3209 30.0153 10.5795L29.3646 11.2195L28.682 10.5609L29.2126 10.0222ZM2.21797 14.8329C2.61131 14.9089 3.26864 14.9436 3.26864 14.9436C3.26864 14.9436 2.75931 18.8622 6.26997 22.6796C3.91131 21.2489 1.64864 18.2316 2.21664 14.8329H2.21797ZM3.18597 13.0689L3.95931 13.3409L3.44997 14.2502L2.50731 13.9395C2.64997 13.6089 3.18597 13.0689 3.18597 13.0689Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.1674 3.4661C15.4701 2.5101 18.2701 2.60477 20.4914 3.7581C22.5581 4.8301 23.6687 7.1421 24.1581 9.20477C25.9367 16.7088 20.8887 21.8261 18.5647 22.6874C18.7221 22.9181 19.0581 23.4661 19.0727 23.9501C18.5901 24.1981 17.7327 24.2168 17.7327 24.2168L17.9754 22.8114C15.5287 22.6608 12.1447 20.3901 10.2234 16.8794C9.37539 15.3261 8.75672 13.5381 8.59672 11.8021C8.49272 10.7088 8.49005 9.54343 8.73672 8.46477C8.85672 7.9421 9.05405 7.4101 9.30472 6.92743C9.68339 6.20077 10.3327 5.46343 10.9367 4.8901C11.5887 4.28525 12.3443 3.80287 13.1674 3.4661Z",
    fill: "url(#paint2_linear_9299_1709)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.726 6.53268C11.058 6.82068 11.654 7.20201 11.654 7.20201C11.654 7.20201 9.52871 11.2513 11.1727 17.2873C9.59004 14.4807 8.76337 9.97935 10.726 6.53268ZM12.3687 5.09668L12.9714 5.79935L12.1154 6.53668L11.37 5.70068C11.6434 5.40868 12.3687 5.09668 12.3687 5.09668Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9299_1709",
    x1: 20.1108,
    y1: 946.698,
    x2: 1254.14,
    y2: 946.698,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8400"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F6FA00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_9299_1709",
    x1: 1.12378,
    y1: 854.865,
    x2: 1455.68,
    y2: 854.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF0C2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF8400"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9299_1709",
    x1: 8.53003,
    y1: 1072.93,
    x2: 1608.56,
    y2: 1072.93,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ff4e00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0099FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidsIcon);
export default __webpack_public_path__ + "static/media/kidsIcon.bf3dd576e89fc70de69cf679fa4a8296.svg";
export { ForwardRef as ReactComponent };